var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgEthniki(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_3081_16670)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M32 0H0V32H32V0Z",
    fill: "#F5F7F9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.1345 25.3406C19.4685 25.7571 17.7375 25.9783 16.0195 25.9783C12.6356 25.9783 9.00434 25.0412 6.24512 23.3492C4.86551 22.5033 3.70716 21.4881 2.8872 20.3037C2.08026 19.1323 1.61172 17.8048 1.61172 16.3341C1.61172 16.295 1.61172 16.256 1.61172 16.2299C1.61172 16.2039 1.61172 16.1779 1.61172 16.1518C1.61172 14.6941 2.08026 13.3796 2.91323 12.2082C4.14968 10.4642 6.18004 9.05857 8.56182 8.09545C10.9306 7.13232 13.6377 6.61172 16.1757 6.61172C19.5987 6.61172 23.1258 7.52278 25.7939 9.20174C27.1345 10.0347 28.2538 11.0629 29.0607 12.2603C29.8547 13.4577 30.3362 14.7983 30.3883 16.321L30.7007 16.308L30.3883 16.295C30.2581 18.6117 29.1909 20.538 27.5249 22.0738C25.859 23.5835 23.5944 24.7028 21.1345 25.3406L21.2907 25.9393C23.8416 25.2755 26.1844 24.1302 27.9414 22.5163C29.6985 20.9024 30.8698 18.82 31 16.321V16.308V16.295C30.9479 14.6551 30.4143 13.1844 29.5683 11.9089C28.2798 9.99566 26.2495 8.52495 23.8807 7.52278C21.5119 6.52061 18.8178 6 16.1757 6C12.6746 6 8.91323 6.93709 5.99783 8.66811C4.54013 9.52712 3.29067 10.5944 2.40564 11.8568C1.52061 13.1063 1 14.564 1 16.1518C1 16.1779 1 16.2039 1 16.243H1.31237H1C1 16.282 1 16.321 1 16.3601C1 17.961 1.52061 19.4187 2.39263 20.6811C3.70716 22.5813 5.81562 24.0521 8.23644 25.0672C10.6573 26.0824 13.4165 26.6161 16.0325 26.6161C17.7896 26.6161 19.5857 26.3948 21.2907 25.9653L21.1345 25.3406Z",
    fill: "#C69B58"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.51172 12.2735L5.20369 12.7941L13.221 12.8201L13.2471 12.2995L16.0323 11.2323L18.7655 12.2735C18.8827 12.3906 18.8176 12.6379 18.8176 12.7941L26.5486 12.8201L28.5269 12.2735C28.2536 11.883 27.6419 11.1802 27.2254 10.7637C22.0193 6.28649 13.2861 5.9481 7.37723 9.00667C5.97159 9.87869 4.57896 10.8678 3.51172 12.2735Z",
    fill: "#007581"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.8501 20.6289L5.43795 20.6549H12.336H13.3121H16.0714L18.5833 20.681C19.0779 20.681 18.6614 20.707 19.7286 20.681H28.1885C27.9412 21.0454 27.5768 21.3708 27.1603 21.7873C21.9802 26.2385 13.2471 26.6029 7.33817 23.5183C5.93253 22.6463 4.93036 22.0345 3.8501 20.6289Z",
    fill: "#007581"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.4359 14.7202H16.0454V15.9827H16.4359V14.7202Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.0454 14.7202H16.4359V15.9697H16.0584V14.7202H16.0454V15.9827H16.4489V14.7202H16.0454Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.9808 14.7202H15.5903V15.9827H15.9808V14.7202Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.5902 14.7202H15.9676V15.9697H15.5902V14.7202H15.5771V15.9827H15.9806V14.7202H15.5771H15.5902Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.4881 14.3687H15.603V14.6159H16.4881V14.3687Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.603 14.6159V14.629H16.5011V14.3687H15.603V14.6159V14.629V14.6159H15.616V14.3817H16.4881V14.6159H15.603H15.616H15.603Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.2906 19.9785V17.909C15.3426 17.3103 15.7331 17.2453 15.9934 17.2192C16.2667 17.2453 16.6572 17.3234 16.7222 17.909V19.9785H15.2906Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.2908 19.9781V17.9087C15.3429 17.323 15.7203 17.2449 15.9937 17.2189C16.267 17.2449 16.6444 17.31 16.7225 17.9087V19.9781H15.2908H16.7355V17.8957C16.6574 17.297 16.267 17.2189 15.9937 17.1929C15.7203 17.2189 15.3299 17.297 15.2778 17.8957L15.2908 19.9781Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.2039 18.4033H16.9306V18.7287H17.2039V18.4033Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.9306 18.4036H17.1909V18.716H16.9306V18.4036H16.9176V18.729H17.2039V18.4036V18.3906H16.9306H16.9176V18.4036H16.9306Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.1214 18.4033H14.8481V18.7287H15.1214V18.4033Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.8481 18.729H15.1214V18.4036V18.3906H14.8481V18.729H14.8611V18.4036H15.1084V18.716H14.8481V18.729H14.8611H14.8481Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.0759 16.3208H14.0932V16.3338H18.0759",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.6313 17.8828H15.3168V17.9609H16.6313V17.8828Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.3166 17.9609H16.6442V17.8828H15.3036V17.9609H15.3166V17.8828H16.6312V17.9479H15.3166V17.9609Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.6312 18.8979H16.0195V18.95H16.6312V18.8979Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.0196 18.9503V18.9894H16.6833V18.8983V18.8462H15.9805V18.9503V18.9894H16.0196V18.9503H16.0716V18.9373H16.5922V18.9503H16.6313V18.8983H16.0196V18.9503H16.0716H16.0196Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.6312 19.5879H16.0195V19.64H16.6312V19.5879Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.0195 19.6398H16.6442V19.5877V19.5747H16.0195V19.6398H16.0325V19.5877H16.6312V19.6268H16.0195V19.6398H16.0325H16.0195Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.9545 18.8979H15.3168V18.95H15.9545V18.8979Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.3169 18.9503V18.9894H15.9937V18.8983V18.8462H15.2778V18.9503V18.9894H15.3169V18.9503H15.3559V18.9373H15.9026V18.9503H15.9546V18.8983H15.3169V18.9503H15.3559H15.3169Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.9545 19.5879H15.3168V19.64H15.9545V19.5879Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.3166 19.6398H15.9544V19.5877V19.5747H15.3036V19.6398H15.3166V19.5877H15.9414V19.6268H15.3166V19.6398Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.6314 18.2471H16.4883V18.4944H16.6314V18.2471Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.4883 18.4944V18.5074H16.6314H16.6445V18.2471H16.4883V18.4944V18.5074V18.4944H16.5013V18.2601H16.6314V18.4944H16.4883H16.5013H16.4883Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.9547 18.2471H15.8115V18.4944H15.9547V18.2471Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.8113 18.4944V18.5074H15.9545V18.2471H15.8113H15.7983V18.4944V18.5074H15.8113V18.4944V18.2601H15.9415V18.4944H15.8113Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.4619 18.2471H16.3447V18.4944H16.4619V18.2471Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.345 18.4944V18.5074H16.4621H16.4751V18.2471H16.345H16.3319V18.4944V18.5074H16.345V18.4944V18.2601H16.4621V18.4944H16.345Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.7075 18.2471H15.5903V18.4944H15.7075V18.2471Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.5902 18.4944V18.5074H15.7073V18.2471H15.5902H15.5771V18.4944V18.5074H15.5902V18.4944V18.2601H15.7073V18.4944H15.5902Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.2409 18.2471H16.0977V18.4944H16.2409V18.2471Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.0977 18.4944V18.5074H16.2409H16.2539V18.2471H16.0977V18.4944V18.5074V18.4944H16.1107V18.2601H16.2409V18.4944H16.0977H16.1107H16.0977Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.5509 18.2471H15.4078V18.4944H15.5509V18.2471Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.4078 18.4944V18.5074H15.5639V18.2471H15.4078V18.4944V18.5074V18.4944H15.4208V18.2601H15.5509V18.4944H15.4078H15.4208H15.4078Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.6314 18.5205H16.4883V18.7418H16.6314V18.5205Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.4883 18.7418V18.7548H16.6314H16.6445V18.5205H16.4883V18.7418V18.7548V18.7418H16.5013V18.5335H16.6314V18.7418H16.4883H16.5013H16.4883Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.9547 18.5205H15.8115V18.7418H15.9547V18.5205Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.8113 18.7418V18.7548H15.9545V18.5205H15.8113H15.7983V18.7418V18.7548H15.8113V18.7418V18.5335H15.9415V18.7418H15.8113Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.4619 18.5205H16.3447V18.7418H16.4619V18.5205Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.345 18.7418V18.7548H16.4621H16.4751V18.5205H16.345H16.3319V18.7418V18.7548H16.345V18.7418V18.5335H16.4621V18.7418H16.345Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.7075 18.5205H15.5903V18.7418H15.7075V18.5205Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.5902 18.7418V18.7548H15.7073V18.5205H15.5902H15.5771V18.7418V18.7548H15.5902V18.7418V18.5335H15.7073V18.7418H15.5902Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.2409 18.5205H16.0977V18.7418H16.2409V18.5205Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.0977 18.7418V18.7548H16.2409H16.2539V18.5205H16.0977V18.7418V18.7548V18.7418H16.1107V18.5335H16.2409V18.7418H16.0977H16.1107H16.0977Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.5509 18.5205H15.4078V18.7418H15.5509V18.5205Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.4078 18.7418V18.7548H15.5639V18.5205H15.4078V18.7418V18.7548V18.7418H15.4208V18.5335H15.5509V18.7418H15.4078H15.4208H15.4078Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.6572 19.7051H16.5401V19.8352H16.6572V19.7051Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.5399 19.8352H16.657H16.67V19.7051H16.5399H16.5269V19.8352H16.5399V19.7181H16.657V19.8222H16.5399V19.8352Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.9547 19.7051H15.8115V19.8352H15.9547V19.7051Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.8113 19.8352H15.9545V19.7051H15.8113H15.7983V19.8352H15.8113V19.7181H15.9415V19.8222H15.8113V19.8352Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.4361 19.7051H16.293V19.8352H16.4361V19.7051Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.293 19.8352H16.4361H16.4492V19.7051H16.293V19.8352H16.306V19.7181H16.4361V19.8222H16.293V19.8352H16.306H16.293Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.7075 19.7051H15.5903V19.8352H15.7075V19.7051Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.5902 19.8352H15.7073V19.7051H15.5902H15.5771V19.8352H15.5902V19.7181H15.7073V19.8222H15.5902V19.8352Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.2409 19.7051H16.0977V19.8352H16.2409V19.7051Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.0977 19.8352H16.2409H16.2539V19.7051H16.0977V19.8352H16.1107V19.7181H16.2409V19.8222H16.0977V19.8352H16.1107H16.0977Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.5122 19.7051H15.395V19.8352H15.5122V19.7051Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.3949 19.8352H15.512V19.7051H15.3949H15.3818V19.8352H15.3949V19.7181H15.512V19.8222H15.3949V19.8352Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.154 12.9369L16.0195 12.2471L13.9501 12.9369H18.154Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.154 12.9369L16.0195 12.2471L13.9501 12.9369V12.9499H18.154V12.9369H13.9891L16.0195 12.2601L18.154 12.9499V12.9369Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.2189 12.742L18.0237 12.9373L15.9933 12.2735L13.989 12.9373L13.8068 12.7551L15.9933 12.0132L18.2189 12.742L15.9933 12.0002L13.7808 12.742L13.989 12.9503L15.9933 12.2865L18.0237 12.9503L18.2189 12.742ZM18.245 12.69V12.3646H18.232L18.0367 12.6119L18.245 12.69L18.0628 12.6119L18.245 12.3906V12.69ZM13.8458 12.69V12.3906L14.028 12.6119L13.8458 12.69L14.0411 12.6249H14.0541L13.8589 12.3776H13.8458V12.69ZM16.0064 11.6878L16.1886 12.0522L16.0064 12.0002L15.8241 12.0653L16.0064 11.6878L15.8111 12.0783L15.8241 12.0913L16.0194 12.0132L16.2146 12.0653H16.2276L16.0194 11.6748L16.0064 11.6878Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.3991 12.9632L16.0065 12.4946L14.6529 12.9632H17.3991Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.3991 12.9632L16.0065 12.4946L14.6529 12.9632V12.9762H17.3991V12.9632H14.692L16.0065 12.5076L17.3861 12.9762L17.3991 12.9632Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.0999 13.1845L29.204 13.3927L28.4361 13.1454L26.9915 13.614L26.9264 13.4708L28.4361 12.9502L29.0999 13.1975V13.1845L29.0869 13.1975L28.4361 12.9502L26.9134 13.4708L26.9915 13.627L28.4361 13.1584L29.2171 13.4057L29.2301 13.3927L29.0999 13.1845ZM2.92639 13.2105L2.82227 13.4318V13.4448L3.69428 13.1454L5.08691 13.64L5.165 13.4838L3.64222 12.9632L2.92639 13.2105L3.62921 12.9762L5.13897 13.4968L5.07389 13.64L3.68127 13.1454L2.83528 13.4318L2.92639 13.2105Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.282 13.536L29.2039 13.3928L28.449 13.1455L27.0824 13.6401H29.321L29.282 13.536Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.2819 13.5358L29.2038 13.3796L28.4489 13.1323L27.0693 13.6269L27.0823 13.6399H29.334L29.2819 13.5358H29.2689L29.321 13.6269H27.1084L28.4489 13.1453L29.2038 13.3926L29.2689 13.5358H29.2819Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2.731 13.6401L2.82211 13.4318L3.68111 13.1455L5.09977 13.6401H2.731Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2.73128 13.6399L2.82238 13.4447L3.68138 13.1453L5.061 13.6269H2.73128V13.6399H5.10004V13.6269L3.68138 13.1323L2.82238 13.4317L2.71826 13.6269V13.6399H2.73128Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.321 13.5881L29.2819 13.562L28.488 13.2627L27.4858 13.6141H29.321V13.5881Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.321 13.5881L29.334 13.5751L29.2819 13.549L28.488 13.2627L27.4858 13.6011V13.6141H29.334V13.5881V13.5751L29.321 13.5881V13.6011H27.5249L28.488 13.2757L29.2689 13.562L29.321 13.5881Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2.731 13.6141L2.74402 13.5881L3.65508 13.2627L4.63122 13.6141H2.731Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2.73111 13.6141L2.75714 13.5881L3.65519 13.2757L4.59228 13.6011H2.73111V13.6141H4.63133V13.6011L3.65519 13.2627L2.74412 13.5751L2.71809 13.6011L2.70508 13.6141H2.73111Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.9784 13.4058V13.1064L27.1606 13.3277L26.9784 13.4058L27.1737 13.3407H27.1867L26.9914 13.0934H26.9784V13.4058ZM5.13895 13.4058V13.0804H5.12593L4.93071 13.3277L5.13895 13.4058L4.95674 13.3277L5.13895 13.1064V13.4058ZM28.4491 12.6899L28.6053 13.0023L28.4491 12.9633L28.293 13.0153L28.4491 12.6899L28.2669 13.0153L28.4491 12.9633L28.6183 13.0153H28.6314L28.4491 12.6899ZM3.60316 12.6899L3.42094 13.0283L3.43396 13.0414L3.60316 12.9633L3.79838 13.0153L3.8114 13.0023L3.60316 12.6899L3.78537 13.0023L3.60316 12.9502L3.44697 13.0153L3.60316 12.6899Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.8916 14.4468H28.0586V14.5509H28.8916V14.4468Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.0584 14.5509H28.8914V14.4468H28.0454V14.5509H28.0584V14.4598H28.8784V14.5379H28.0584V14.5509Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.6919 14.4468H25.859V14.5509H26.6919V14.4468Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.8587 14.5509H26.6917V14.4468H25.8457V14.5509H25.8587V14.4598H26.6787V14.5379H25.8587V14.5509Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.2475 14.4468H24.4146V14.5509H25.2475V14.4468Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.4143 14.5509H25.2473V14.4468H24.4013V14.5509H24.4143V14.4598H25.2343V14.5379H24.4143V14.5509Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.8027 14.4468H22.9697V14.5509H23.8027V14.4468Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.9696 14.5509H23.8025V14.4468H22.9565V14.5509H22.9696V14.4598H23.7895V14.5379H22.9696V14.5509Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.3579 14.4468H21.525V14.5509H22.3579V14.4468Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.525 14.5509H22.3579V14.4468H21.525V14.5509H21.538V14.4598H22.3449V14.5379H21.525V14.5509H21.538H21.525Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.8481 14.4468H20.0151V14.5509H20.8481V14.4468Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.015 14.5509H20.8479V14.4468H20.002V14.5509H20.015V14.4598H20.8349V14.5379H20.015V14.5509Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.4033 14.4468H18.5703V14.5509H19.4033V14.4468Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.5706 14.5509H19.4036V14.4468H18.5576V14.5509H18.5706V14.4598H19.3906V14.5379H18.5706V14.5509Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.07174 14.4468H3.23877V14.5509H4.07174V14.4468Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.23856 14.4468V14.4598H4.05851V14.5379H3.23856V14.4468V14.4598V14.4468H3.22554V14.5509H4.07153V14.4468H3.22554H3.23856Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.27096 14.4468H5.43799V14.5509H6.27096V14.4468Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.43799 14.4468V14.4598H6.25795V14.5379H5.43799V14.4468V14.4598V14.4468V14.5509H6.27096V14.4468H5.43799Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.71578 14.4468H6.88281V14.5509H7.71578V14.4468Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.88264 14.4468V14.4598H7.7026V14.5379H6.88264V14.4468V14.4598V14.4468H6.86963V14.5509H7.71562V14.4468H6.86963H6.88264Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.16046 14.4468H8.35352V14.5509H9.16046V14.4468Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.35383 14.4468V14.4598H9.14776V14.5379H8.35383V14.4468V14.4598V14.4468H8.34082V14.5509H9.16078V14.4468H8.34082H8.35383Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.6445 14.4468H9.81152V14.5509H10.6445V14.4468Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.81152 14.4468V14.4598H10.6445V14.5379H9.82454V14.4468H9.81152V14.4598V14.4468V14.5509H10.6575V14.4468H9.81152Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.141 14.4468H11.334V14.5509H12.141V14.4468Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.3338 14.4468V14.4598H12.1277V14.5379H11.3338V14.4468V14.4598V14.4468H11.3208V14.5509H12.1408V14.4468H11.3208H11.3338Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.5858 14.4468H12.7788V14.5509H13.5858V14.4468Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.7786 14.4468V14.4598H13.5726V14.5379H12.7786V14.4468V14.4598V14.4468H12.7656V14.5509H13.5856V14.4468H12.7656H12.7786Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.4639 13.9785V16.2952H29.477L29.4639 13.9785ZM27.4596 13.8613V16.3082H27.4726L27.4596 13.8613ZM2.63965 13.8613V16.3082H2.65266L2.63965 13.8613ZM4.64399 13.8613V16.3082H4.657L4.64399 13.8613ZM29.8934 16.2952H18.0626V16.3082L29.8934 16.2952Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.3472 18.7808H18.024V18.8589H29.3472",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2.13232 16.3079H14.0933V16.2949H2.13232",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2.6792 18.8589H14.0675V18.7808H2.6792",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.4254 13.8481H18.0501V13.8612L29.4254 13.8481ZM29.8939 16.5943H18.0371V16.6074L29.8939 16.5943Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.204 19.0801H18.024V19.1582H29.204",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2.62675 13.8612H14.0931V13.8481L2.62675 13.8612ZM2.1582 16.6074H14.0671V16.5943L2.1582 16.6074Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2.84819 19.1582H14.0673V19.0801H2.84819",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27.7333 19.783H18.024V19.796L27.7333 19.783ZM27.0435 13.6138V20.681H27.0565L27.0435 13.6138ZM29.8678 16.9847H29.2301V16.9977L29.8678 16.9847ZM27.7333 16.9847H27.0435V16.9977L27.7333 16.9847ZM29.8157 17.2841H29.2301V17.2971L29.8157 17.2841ZM27.7333 17.2841H27.0435V17.2971L27.7333 17.2841ZM29.7377 17.6355H29.2301V17.6485L29.7377 17.6355ZM27.7333 17.6355H27.0435V17.6485L27.7333 17.6355ZM29.6726 17.9478H29.2301V17.9608L29.6726 17.9478ZM27.7333 17.9478H27.0435V17.9608L27.7333 17.9478ZM29.5685 18.2472H29.2301V18.2602L29.5685 18.2472ZM27.7333 18.2472H27.0435V18.2602L27.7333 18.2472Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.4513 18.5854H29.23V18.6766H29.4513V18.5854ZM27.7333 18.5854H27.0435V18.6766H27.7333V18.5854Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27.7333 19.4579H18.024V19.4709L27.7333 19.4579ZM27.7333 20.0957H18.024V20.1087L27.7333 20.0957ZM28.1758 20.6683H18.089L18.063 13.6141H26.9263V13.6011H18.05L18.076 20.6813L28.1758 20.6683ZM4.38404 19.7963H14.0934V19.7833L4.38404 19.7963ZM5.04782 13.6141V20.6813H5.06084L5.04782 13.6141ZM2.18448 16.998H2.93936V16.985L2.18448 16.998ZM4.38404 16.998H5.07385V16.985L4.38404 16.998ZM2.23654 17.2974H2.93936V17.2844L2.23654 17.2974ZM4.38404 17.2974H5.07385V17.2844L4.38404 17.2974ZM2.2886 17.6358H2.95237V17.6228L2.2886 17.6358ZM4.38404 17.6358H5.07385V17.6228L4.38404 17.6358ZM2.37971 17.9612H2.93936V17.9481L2.37971 17.9612ZM4.38404 17.9612H5.07385V17.9481L4.38404 17.9612ZM2.48383 18.2605H2.95237V18.2475L2.48383 18.2605ZM4.38404 18.2605H5.07385V18.2475L4.38404 18.2605Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2.62686 18.6639H2.93923V18.5728H2.62686V18.6639ZM4.38391 18.6639H5.07372V18.5728H4.38391V18.6639Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.38387 19.4706H14.0932V19.4576L4.38387 19.4706ZM4.38387 20.1083H14.0932V20.0953L4.38387 20.1083ZM3.82422 20.655H14.0932V13.5747H5.08669V13.5877H14.0802V20.642L3.82422 20.655Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.4492 14.9155H28.1499V16.0218H28.4492V14.9155Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.1499 16.0348H28.4492V14.9155H28.1499V16.0348H28.1629V14.9285H28.4362V16.0218H28.1499V16.0348H28.1629H28.1499Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.2496 14.9155H25.9503V16.0218H26.2496V14.9155Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.9503 16.0348H26.2496V14.9155H25.9503V16.0348H25.9633V14.9285H26.2366V16.0218H25.9503V16.0348H25.9633H25.9503Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.2496 17.3882H25.9503V18.5465H26.2496V17.3882Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.9503 18.5465V18.5596H26.2496V17.3882H25.9503V18.5596V18.5465H25.9633V17.3882H26.2366V18.5465H25.9503H25.9633H25.9503Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.8048 17.3882H24.5055V18.5465H24.8048V17.3882Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.5055 18.5465V18.5596H24.8048V17.3882H24.5055V18.5596V18.5465H24.5185V17.3882H24.7918V18.5465H24.5055H24.5185H24.5055Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.3599 17.3882H23.0605V18.5465H23.3599V17.3882Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.0605 18.5465V18.5596H23.3599V17.3882H23.0605V18.5596V18.5465H23.0736V17.3882H23.3599V18.5465H23.0605H23.0736H23.0605Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.8763 17.3882H21.603V18.5465H21.8763V17.3882Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.6029 18.5465V18.5596H21.8632H21.8762V17.3882H21.6029H21.5898V18.5596H21.6029V18.5465V17.3882H21.8632V18.5465H21.6029Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.3535 17.3882H20.0802V18.5465H20.3535V17.3882Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.0802 18.5465V18.5596H20.3535V17.3882H20.0802V18.5596V18.5465H20.0932V17.3882H20.3405V18.5465H20.0802H20.0932H20.0802Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.9091 17.3882H18.6357V18.5465H18.9091V17.3882Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.6357 18.5465V18.5596H18.9091H18.9221V17.3882H18.6357V18.5596V18.5465H18.6488V17.3882H18.9091V18.5465H18.6357H18.6488H18.6357Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.8048 14.9155H24.5055V16.0218H24.8048V14.9155Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.5055 16.0348H24.8048V14.9155H24.5055V16.0348H24.5185V14.9285H24.7918V16.0218H24.5055V16.0348H24.5185H24.5055Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.3599 14.9155H23.0605V16.0218H23.3599V14.9155Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.0605 16.0348H23.3599V14.9155H23.0605V16.0348H23.0736V14.9285H23.3599V16.0218H23.0605V16.0348H23.0736H23.0605Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.8763 14.9155H21.603V16.0218H21.8763V14.9155Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.6029 16.0348H21.8632H21.8762V14.9155H21.6029H21.5898V16.0348H21.6029V14.9285H21.8632V16.0218H21.6029V16.0348Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.3535 14.9155H20.0802V16.0218H20.3535V14.9155Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.0802 16.0348H20.3535V14.9155H20.0802V16.0348H20.0932V14.9285H20.3405V16.0218H20.0802V16.0348H20.0932H20.0802Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.9091 14.9155H18.6357V16.0218H18.9091V14.9155Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.6357 16.0348H18.9091H18.9221V14.9155H18.6357V16.0348H18.6488V14.9285H18.9091V16.0218H18.6357V16.0348H18.6488H18.6357Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.8135 14.9155H28.5142V16.0218H28.8135V14.9155Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.5142 16.0348H28.8135V14.9155H28.5142V16.0348H28.5272V14.9285H28.8005V16.0218H28.5142V16.0348H28.5272H28.5142Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.6139 14.9155H26.3145V16.0218H26.6139V14.9155Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.3145 16.0348H26.6139V14.9155H26.3145V16.0348H26.3276V14.9285H26.6009V16.0218H26.3145V16.0348H26.3276H26.3145Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.6139 17.3882H26.3145V18.5465H26.6139V17.3882Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.3145 18.5465V18.5596H26.6139V17.3882H26.3145V18.5596V18.5465H26.3276V17.3882H26.6009V18.5465H26.3145H26.3276H26.3145Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.1429 17.3882H24.8696V18.5465H25.1429V17.3882Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.8696 18.5465V18.5596H25.1429H25.156V17.3882H24.8696V18.5596V18.5465H24.8826V17.3882H25.1429V18.5465H24.8696H24.8826H24.8696Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.7114 17.3882H23.438V18.5465H23.7114V17.3882Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.4383 18.5465V18.5596H23.6986H23.7116V17.3882H23.4383H23.4253V18.5596H23.4383V18.5465V17.3882H23.6986V18.5465H23.4383Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.2669 17.3882H21.9936V18.5465H22.2669V17.3882Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.9934 18.5465V18.5596H22.2537H22.2667V17.3882H21.9934H21.9804V18.5596H21.9934V18.5465V17.3882H22.2537V18.5465H21.9934Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.744 17.3882H20.4707V18.5465H20.744V17.3882Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.4707 18.5465V18.5596H20.744V17.3882H20.4707V18.5596V18.5465H20.4837V17.3882H20.744V18.5465H20.4707H20.4837H20.4707Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.3124 17.3882H19.0391V18.5465H19.3124V17.3882Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.0389 18.5465V18.5596H19.2992H19.3122V17.3882H19.0389H19.0259V18.5596H19.0389V18.5465V17.3882H19.2992V18.5465H19.0389Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.1429 14.9155H24.8696V16.0218H25.1429V14.9155Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.8696 16.0348H25.1429H25.156V14.9155H24.8696V16.0348H24.8826V14.9285H25.1429V16.0218H24.8696V16.0348H24.8826H24.8696Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.7114 14.9155H23.438V16.0218H23.7114V14.9155Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.4383 16.0348H23.6986H23.7116V14.9155H23.4383H23.4253V16.0348H23.4383V14.9285H23.6986V16.0218H23.4383V16.0348Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.2669 14.9155H21.9936V16.0218H22.2669V14.9155Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.9934 16.0348H22.2537H22.2667V14.9155H21.9934H21.9804V16.0348H21.9934V14.9285H22.2537V16.0218H21.9934V16.0348Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.744 14.9155H20.4707V16.0218H20.744V14.9155Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.4707 16.0348H20.744V14.9155H20.4707V16.0348H20.4837V14.9285H20.744V16.0218H20.4707V16.0348H20.4837H20.4707Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.3124 14.9155H19.0391V16.0218H19.3124V14.9155Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.0389 16.0348H19.2992H19.3122V14.9155H19.0389H19.0259V16.0348H19.0389V14.9285H19.2992V16.0218H19.0389V16.0348Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.5881 17.0371H25.9243V17.2844H26.5881V17.0371Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.9243 17.0371V17.0501H26.5751V17.2844H25.9373V17.0371H25.9243V17.0501V17.0371V17.2844V17.2974H26.5881V17.0371H25.9243Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.5881 14.5771H25.9243V14.7984H26.5881V14.5771Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.9243 14.577H26.5751V14.7852H25.9373V14.577H25.9243V14.7982H26.5881V14.577V14.564H25.9243V14.577Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.7874 14.5771H28.1236V14.7984H28.7874V14.5771Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.1236 14.577H28.7874V14.7852H28.1366V14.577H28.1236V14.7982H28.7874V14.577V14.564H28.1236V14.577Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.1432 17.0371H24.4794V17.2844H25.1432V17.0371Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.4794 17.0371V17.0501H25.1432V17.2844H24.4924V17.0371H24.4794V17.0501V17.0371V17.2844V17.2974H25.1562V17.0371H24.4794Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.1432 14.5771H24.4794V14.7984H25.1432V14.5771Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.4794 14.577H25.1432V14.7852H24.4924V14.577H24.4794V14.7982H25.1562V14.577V14.564H24.4794V14.577Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.7116 17.0371H23.0479V17.2844H23.7116V17.0371Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.0478 17.0371V17.0501H23.6985V17.2844H23.0478V17.0371V17.0501V17.0371H23.0348V17.2844V17.2974H23.7115V17.0371H23.0348H23.0478Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.7116 14.5771H23.0479V14.7984H23.7116V14.5771Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.0478 14.577H23.6985V14.7852H23.0478V14.577H23.0348V14.7982H23.7115V14.577V14.564H23.0348V14.577H23.0478Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.2668 17.0371H21.603V17.2844H22.2668V17.0371Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.6029 17.0371V17.0501H22.2536V17.2844H21.6029V17.0371V17.0501V17.0371H21.5898V17.2844V17.2974H22.2666V17.0371H21.5898H21.6029Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.2668 14.5771H21.603V14.7984H22.2668V14.5771Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.6029 14.577H22.2536V14.7852H21.6029V14.577H21.5898V14.7982H22.2666V14.577V14.564H21.5898V14.577H21.6029Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.7439 17.0371H20.0802V17.2844H20.7439V17.0371Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.0802 17.0371V17.0501H20.7439V17.2844H20.0932V17.0371H20.0802V17.0501V17.0371V17.2844V17.2974H20.7439V17.0371H20.0802Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.7439 14.5771H20.0802V14.7984H20.7439V14.5771Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.0802 14.577H20.7439V14.7852H20.0932V14.577H20.0802V14.7982H20.7439V14.577V14.564H20.0802V14.577Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.2995 17.0371H18.6357V17.2844H19.2995V17.0371Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.6357 17.0371V17.0501H19.2995V17.2844H18.6488V17.0371H18.6357V17.0501V17.0371V17.2844V17.2974H19.3125V17.0371H18.6357Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.2995 14.5771H18.6357V14.7984H19.2995V14.5771Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.6357 14.577H19.2995V14.7852H18.6488V14.577H18.6357V14.7982H19.3125V14.577V14.564H18.6357V14.577Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.0998 16.9199H28.5401V17.3104H29.0998V16.9199Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.5401 17.3102V17.3232H29.1128V16.9067H28.5401V17.3232V17.3102H28.5531V16.9198H29.0998V17.3102H28.5401H28.5531H28.5401Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.4231 16.9199H27.8374V17.3104H28.4231V16.9199Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27.8372 17.3102V17.3232H28.4229V16.9067H27.8242V17.3232H27.8372V17.3102V16.9198H28.4099V17.3102H27.8372Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.0998 17.3882H28.5401V18.5986H29.0998V17.3882Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.5401 18.5986V18.6116H29.1128V17.3882H28.5401V18.6116V18.5986H28.5531V17.3882H29.0998V18.5986H28.5401H28.5531H28.5401Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.4231 17.3882H27.8374V18.5986H28.4231V17.3882Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27.8372 18.5986V18.6116H28.4229V17.3882H27.8242V18.6116H27.8372V18.5986V17.3882H28.4099V18.5986H27.8372Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.0998 19.2104H28.5401V20.1345H28.5661L29.0998 19.2104Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.0998 19.2104H28.5401V20.1345H28.5661L29.1128 19.2104H29.0998L28.5661 20.1215H28.5531V19.2235H29.0998V19.2104Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.4231 19.2104H27.8374V20.1215H28.4231V19.2104Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27.8372 20.1345H28.4229V19.2104H27.8242V20.1345H27.8372V19.2235H28.4099V20.1215H27.8372V20.1345Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.614 19.3145H25.9503V20.1344H26.614V19.3145Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.9503 20.1344H26.614V19.3145H25.9503V20.1344H25.9633V19.3275H26.601V20.1214H25.9503V20.1344H25.9633H25.9503Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.1692 19.3145H24.5055V20.1344H25.1692V19.3145Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.5055 20.1344H25.1692V19.3145H24.5055V20.1344H24.5185V19.3275H25.1692V20.1214H24.5055V20.1344H24.5185H24.5055Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.7243 19.3145H23.0605V20.1344H23.7243V19.3145Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.0605 20.1344H23.7373V19.3145H23.0605V20.1344H23.0736V19.3275H23.7243V20.1214H23.0605V20.1344H23.0736H23.0605Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.2669 19.3145H21.5771V20.1344H22.2669V19.3145Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.5769 20.1344H22.2667V19.3145H21.5639V20.1344H21.5769V19.3275H22.2537V20.1214H21.5769V20.1344Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.7439 19.3145H20.0802V20.1344H20.7439V19.3145Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.0802 20.1344H20.7439V19.3145H20.0802V20.1344H20.0932V19.3275H20.7439V20.1214H20.0802V20.1344H20.0932H20.0802Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.2995 19.3145H18.6357V20.668H19.2995V19.3145Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.6357 20.668V20.681H19.3125V19.3145H18.6357V20.681V20.668H18.6488V19.3275H19.2995V20.668H18.6357H18.6488H18.6357Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.00623 14.9155H3.73291V16.0218H4.00623V14.9155Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.73323 14.9155V14.9285H3.99353V16.0218H3.73323V14.9155V14.9285V14.9155H3.72021V16.0348H3.99353H4.00655V14.9155H3.73323H3.72021H3.73323Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.20603 14.9155H5.93271V16.0218H6.20603V14.9155Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.93294 14.9155V14.9285H6.19324V16.0218H5.93294V14.9155V14.9285V14.9155H5.91992V16.0348H6.19324H6.20626V14.9155H5.93294H5.91992H5.93294Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.20603 17.3882H5.93271V18.5465H6.20603V17.3882Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.93294 17.3882H6.19324V18.5465H5.93294V17.3882H5.91992V18.5596H6.19324H6.20626V17.3882H5.93294H5.91992H5.93294Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.63758 17.3882H7.36426V18.5465H7.63758V17.3882Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.36426 17.3882H7.63758V18.5465H7.37727V17.3882H7.36426V18.5596H7.63758H7.65059V17.3882H7.36426Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.0824 17.3882H8.80908V18.5465H9.0824V17.3882Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.80908 17.3882H9.06939V18.5465H8.8221V17.3882H8.80908V18.5596H9.0824V17.3882H8.80908Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.5791 17.3882H10.2798V18.5465H10.5791V17.3882Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.2798 17.3882H10.5661V18.5465H10.2798V17.3882V18.5596H10.5791V17.3882H10.2798Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.0497 17.3882H11.7764V18.5465H12.0497V17.3882Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.7767 17.3882H12.037V18.5465H11.7767V17.3882H11.7637V18.5596H12.037H12.05V17.3882H11.7767H11.7637H11.7767Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.4818 17.3882H13.2085V18.5465H13.4818V17.3882Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.2085 17.3882H13.4818V18.5465H13.2215V17.3882H13.2085V18.5596H13.4818H13.4948V17.3882H13.2085Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.63758 14.9155H7.36426V16.0218H7.63758V14.9155Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.36426 14.9155V14.9285H7.63758V16.0218H7.37727V14.9155H7.36426V14.9285V14.9155V16.0348H7.63758H7.65059V14.9155H7.36426Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.0824 14.9155H8.80908V16.0218H9.0824V14.9155Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.80908 14.9155V14.9285H9.06939V16.0218H8.8221V14.9155H8.80908V14.9285V14.9155V16.0348H9.0824V14.9155H8.80908Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.5791 14.9155H10.2798V16.0218H10.5791V14.9155Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.2798 14.9155V14.9285H10.5661V16.0218H10.2798V14.9155V14.9285V14.9155V16.0348H10.5791V14.9155H10.2798Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.0497 14.9155H11.7764V16.0218H12.0497V14.9155Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.7767 14.9155V14.9285H12.037V16.0218H11.7767V14.9155V14.9285V14.9155H11.7637V16.0348H12.037H12.05V14.9155H11.7767H11.7637H11.7767Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.4818 14.9155H13.2085V16.0218H13.4818V14.9155Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.2085 14.9155V14.9285H13.4818V16.0218H13.2215V14.9155H13.2085V14.9285V14.9155V16.0348H13.4818H13.4948V14.9155H13.2085Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.603 14.9155H3.32968V16.0218H3.603V14.9155Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.32968 14.9155V14.9285H3.603V16.0218H3.3427V14.9155H3.32968V14.9285V14.9155V16.0348H3.603H3.61602V14.9155H3.32968Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.8158 14.9155H5.54248V16.0218H5.8158V14.9155Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.54231 14.9155V14.9285H5.80262V16.0218H5.54231V14.9155V14.9285V14.9155H5.5293V16.0348H5.80262H5.81563V14.9155H5.54231H5.5293H5.54231Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.8158 17.3882H5.54248V18.5465H5.8158V17.3882Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.54231 17.3882H5.80262V18.5465H5.54231V17.3882H5.5293V18.5596H5.80262H5.81563V17.3882H5.54231H5.5293H5.54231Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.24739 17.3882H6.97408V18.5465H7.24739V17.3882Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.97408 17.3882H7.24739V18.5465H6.98709V17.3882H6.97408V18.5596H7.24739V17.3882H6.97408Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.69226 17.3882H8.41895V18.5465H8.69226V17.3882Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.41895 17.3882H8.67925V18.5465H8.43196V17.3882H8.41895V18.5596H8.69226V17.3882H8.41895Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.189 17.3882H9.88965V18.5465H10.189V17.3882Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.88939 17.3882H10.1757V18.5465H9.88939V17.3882H9.87637V18.5596H10.1757H10.1887V17.3882H9.88939H9.87637H9.88939Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.6983 17.3882H11.3989V18.5465H11.6983V17.3882Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.3989 17.3882H11.6853V18.5465H11.4119V17.3882H11.3989V18.5596H11.6983V17.3882H11.3989Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.1432 17.3882H12.8438V18.5465H13.1432V17.3882Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.8438 17.3882H13.1302V18.5465H12.8569V17.3882H12.8438V18.5596H13.1432V17.3882H12.8438Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.24739 14.9155H6.97408V16.0218H7.24739V14.9155Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.97408 14.9155V14.9285H7.24739V16.0218H6.98709V14.9155H6.97408V14.9285V14.9155V16.0348H7.24739V14.9155H6.97408Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.69226 14.9155H8.41895V16.0218H8.69226V14.9155Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.41895 14.9155V14.9285H8.67925V16.0218H8.43196V14.9155H8.41895V14.9285V14.9155V16.0348H8.69226V14.9155H8.41895Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.189 14.9155H9.88965V16.0218H10.189V14.9155Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.88939 14.9155V14.9285H10.1757V16.0218H9.88939V14.9155V14.9285V14.9155H9.87637V16.0348H10.1757H10.1887V14.9155H9.88939H9.87637H9.88939Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.6983 14.9155H11.3989V16.0218H11.6983V14.9155Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.3989 14.9155V14.9285H11.6853V16.0218H11.4119V14.9155H11.3989V14.9285V14.9155V16.0348H11.6983V14.9155H11.3989Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.1432 14.9155H12.8438V16.0218H13.1432V14.9155Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.8438 14.9155V14.9285H13.1302V16.0218H12.8569V14.9155H12.8438V14.9285V14.9155V16.0348H13.1432V14.9155H12.8438Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.20625 17.0371H5.54248V17.2844H6.20625V17.0371Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.54231 17.2844V17.2974H6.20609V17.0371H5.5293V17.2844V17.2974H5.54231V17.2844V17.0501H6.19307V17.2844H5.54231Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.20625 14.5771H5.54248V14.7984H6.20625V14.5771Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.54231 14.7982H6.20609V14.577V14.564H5.5293V14.7982H5.54231V14.577H6.19307V14.7852H5.54231V14.7982Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.99345 14.5771H3.32968V14.7984H3.99345V14.5771Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.32968 14.7982H4.00647V14.577V14.564H3.32968V14.7982H3.3427V14.577H3.99345V14.7852H3.32968V14.7982H3.3427H3.32968Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.63785 17.0371H6.97408V17.2844H7.63785V17.0371Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.97408 17.2844V17.2974H7.65086V17.0371H6.97408V17.2844V17.2974V17.2844H6.98709V17.0501H7.63785V17.2844H6.97408H6.98709H6.97408Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.63785 14.5771H6.97408V14.7984H7.63785V14.5771Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.97408 14.7982H7.65086V14.577V14.564H6.97408V14.7982H6.98709V14.577H7.63785V14.7852H6.97408V14.7982H6.98709H6.97408Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.08272 17.0371H8.41895V17.2844H9.08272V17.0371Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.41895 17.2844V17.2974H9.08272V17.0371H8.41895V17.2844V17.2974V17.2844H8.43196V17.0501H9.0697V17.2844H8.41895H8.43196H8.41895Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.08272 14.5771H8.41895V14.7984H9.08272V14.5771Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.41895 14.7982H9.08272V14.577V14.564H8.41895V14.7982H8.43196V14.577H9.0697V14.7852H8.41895V14.7982H8.43196H8.41895Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.5534 17.0371H9.88965V17.2844H10.5534V17.0371Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.88939 17.2844V17.2974H10.5532V17.0371H9.87637V17.2844V17.2974H9.88939V17.2844V17.0501H10.5401V17.2844H9.88939Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.5534 14.5771H9.88965V14.7984H10.5534V14.5771Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.88939 14.7982H10.5532V14.577V14.564H9.87637V14.7982H9.88939V14.577H10.5401V14.7852H9.88939V14.7982Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.0627 17.0371H11.3989V17.2844H12.0627V17.0371Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.3989 17.2844V17.2974H12.0757V17.0371H11.3989V17.2844V17.2974V17.2844H11.4119V17.0501H12.0627V17.2844H11.3989H11.4119H11.3989Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.0627 14.5771H11.3989V14.7984H12.0627V14.5771Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.3989 14.7982H12.0757V14.577V14.564H11.3989V14.7982H11.4119V14.577H12.0627V14.7852H11.3989V14.7982H11.4119H11.3989Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.5076 17.0371H12.8438V17.2844H13.5076V17.0371Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.8438 17.2844V17.2974H13.5076V17.0371H12.8438V17.2844V17.2974V17.2844H12.8569V17.0501H13.4946V17.2844H12.8438H12.8569H12.8438Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.5076 14.5771H12.8438V14.7984H13.5076V14.5771Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.8438 14.7982H13.5076V14.577V14.564H12.8438V14.7982H12.8569V14.577H13.4946V14.7852H12.8438V14.7982H12.8569H12.8438Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.62914 16.9199H3.04346V17.3104H3.62914V16.9199Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.04329 16.9198H3.62897V17.3102H3.04329V16.9198H3.03027V17.3232H3.62897V16.9067H3.03027V16.9198H3.04329Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.29271 16.9199H3.70703V17.3104H4.29271V16.9199Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.70735 16.9198H4.28002V17.3102H3.70735V16.9198H3.69434V17.3232H4.29303V16.9067H3.69434V16.9198H3.70735Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.62914 17.3882H3.04346V18.5986H3.62914V17.3882Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.04329 17.3882H3.62897V18.5986H3.04329V17.3882H3.03027V18.6116H3.62897V17.3882H3.03027H3.04329Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.29271 17.3882H3.70703V18.5986H4.29271V17.3882Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.70735 17.3882H4.28002V18.5986H3.70735V17.3882H3.69434V18.6116H4.29303V17.3882H3.69434H3.70735Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.04346 19.2104H3.62914V20.1345H3.43391L3.04346 19.5358V19.2104Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.04329 19.2104V19.2235H3.62897V20.1215H3.43374L3.04329 19.5358V19.2104V19.2235V19.2104H3.03027V19.5358L3.43374 20.1345H3.62897V19.2104H3.03027H3.04329Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.29271 19.2104H3.70703V20.1215H4.29271V19.2104Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.70735 19.2104V19.2235H4.28002V20.1215H3.70735V19.2104V19.2235V19.2104H3.69434V20.1345H4.29303V19.2104H3.69434H3.70735Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.20625 19.3145H5.54248V20.1344H6.20625V19.3145Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.54231 19.3145V19.3275H6.19307V20.1214H5.54231V19.3145V19.3275V19.3145H5.5293V20.1344H6.20609V19.3145H5.5293H5.54231Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.66388 19.3145H6.97408V20.1344H7.66388V19.3145Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.97408 19.3145V19.3275H7.66388V20.1214H6.98709V19.3145H6.97408V19.3275V19.3145V20.1344H7.66388V19.3145H6.97408Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.10855 19.3145H8.44478V20.1344H9.10855V19.3145Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.44478 19.3145V19.3275H9.09554V20.1214H8.45779V19.3145H8.44478V19.3275V19.3145V20.1344H9.10855V19.3145H8.44478Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.5534 19.3145H9.88965V20.1344H10.5534V19.3145Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.88939 19.3145V19.3275H10.5401V20.1214H9.88939V19.3145V19.3275V19.3145H9.87637V20.1344H10.5532V19.3145H9.87637H9.88939Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.076 19.3145H11.3862V20.1344H12.076V19.3145Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.386 19.3145V19.3275H12.0628V20.1214H11.386V19.3145V19.3275V19.3145H11.373V20.1344H12.0758V19.3145H11.373H11.386Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.5076 19.3145H12.8438V20.668H13.5076V19.3145Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.8438 19.3145V19.3275H13.4946V20.668H12.8569V19.3145H12.8438V19.3275V19.3145V20.681H13.5076V19.3145H12.8438Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.05 16.5942H14.0674V16.6073H18.05",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.6985 15.8135H14.3926V16.3081H17.6985V15.8135Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.3924 16.3079H17.6983V15.8003H14.3794V16.3079H14.3924V15.8133H17.6853V16.2949H14.3924V16.3079Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.7113 13.5098H17.438V16.2299H17.7113V13.5098Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.438 13.5098H17.7113V16.2169H17.451V13.5098H17.438V16.2299H17.7113H17.7243V13.5098H17.438Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.692 13.5098H14.3926V16.2299H14.692V13.5098Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.3924 13.5098H14.6787V16.2169H14.3924V13.5098H14.3794V16.2299H14.6787H14.6918V13.5098H14.3924H14.3794H14.3924Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.0455 16.8936V16.9717C16.0455 16.9717 16.9175 16.9717 16.9175 17.8828H17.3991V16.8806L16.0455 16.8936H17.386V17.8698H16.9305C16.9305 16.9457 16.0455 16.9457 16.0455 16.9457V16.8936ZM16.0194 16.8936V16.9717C16.0194 16.9717 15.1344 16.9717 15.1344 17.8958H14.7049V16.9197L16.0194 16.8936H14.6919V17.8958H15.1474C15.1474 16.9848 16.0194 16.9848 16.0194 16.9848V16.8936ZM16.9565 19.0412H17.4251V17.9479H16.9435L16.9565 19.0412V17.9609H17.4121V19.0412H16.9565ZM14.7309 17.9609H15.1344V19.0412H14.7309V17.9609V19.0542H15.1604V17.9609H14.7309ZM14.7309 19.2104H15.1604V20.1084H14.7309V19.2104V20.1344H15.1865V19.2104H14.7309ZM16.9565 19.2104H17.386V20.1084H16.9565V19.2104V20.1344H17.4121V19.2104H16.9565ZM16.8524 14.1084H15.2125V14.3817H15.3036V15.7874H16.7613V14.3817H16.8524V14.1084V14.3687H16.7613V15.7743H15.3296V14.3687H15.2385V14.1084H16.8524ZM15.1995 14.3557H16.8394V14.1084H15.1865L15.1995 14.3557V14.1084H16.8264V14.3427L15.1995 14.3557Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.8089 14.0042H14.6788V13.8611C14.5877 13.9782 14.4575 13.8611 14.4575 13.7569C14.4835 13.6398 14.5356 13.6138 14.6788 13.6138H14.9261C15.0692 13.6138 15.0953 13.6398 15.1213 13.7569C15.1213 13.8611 15.0172 13.9782 14.9261 13.8611V14.0042H14.8089Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.8089 14.0044H14.6918V13.8612H14.6788C14.6527 13.9003 14.6267 13.9133 14.5877 13.9133C14.5226 13.9133 14.4705 13.8352 14.4705 13.7701C14.4966 13.653 14.5356 13.6269 14.6788 13.6269H14.9261C15.0692 13.6269 15.0953 13.653 15.1213 13.7701C15.1213 13.8352 15.0692 13.9133 15.0172 13.9133C14.9911 13.9133 14.9651 13.9003 14.9391 13.8612H14.9261V14.0044H14.8089H14.9261V13.8482C14.9521 13.8872 14.9911 13.9003 15.0172 13.9003C15.0822 13.9003 15.1343 13.8091 15.1343 13.7441C15.1083 13.6139 15.0822 13.5879 14.9391 13.5879H14.6788C14.5356 13.5879 14.4705 13.6139 14.4575 13.7441C14.4575 13.8222 14.5226 13.9003 14.5877 13.9003C14.6137 13.9003 14.6527 13.8872 14.6788 13.8482V13.9914L14.8089 14.0044Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.321 14.0042H17.4382V13.8611C17.5553 13.9782 17.6594 13.8611 17.6594 13.7569C17.6334 13.6398 17.5813 13.6138 17.4382 13.6138H17.1909C17.0477 13.6138 17.0217 13.6398 16.9957 13.7569C16.9957 13.8611 17.0998 13.9782 17.1909 13.8611V14.0042H17.321Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.321 14.0044H17.4382V13.8482C17.4772 13.8872 17.5163 13.9003 17.5423 13.9003C17.6204 13.9003 17.6724 13.8091 17.6724 13.7441C17.6464 13.6139 17.5943 13.5879 17.4512 13.5879H17.2039C17.0607 13.5879 17.0217 13.6139 16.9957 13.7441C16.9957 13.8091 17.0477 13.9003 17.1128 13.9003C17.1388 13.9003 17.1779 13.8872 17.2039 13.8482V13.9914L17.321 14.0044H17.2039V13.8612H17.1909C17.1648 13.9003 17.1388 13.9133 17.1128 13.9133C17.0607 13.9133 17.0087 13.8352 17.0087 13.7701C17.0347 13.653 17.0477 13.6269 17.2039 13.6269H17.4512C17.5943 13.6269 17.6464 13.653 17.6594 13.7701C17.6594 13.8352 17.6074 13.9133 17.5423 13.9133C17.5163 13.9133 17.4772 13.9003 17.4512 13.8612H17.4382V14.0044H17.321Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.0497 13.1062H14.067V13.1192L18.0497 13.1062ZM18.0497 20.3687H14.041V20.3817L18.0497 20.3687ZM18.0497 20.642H14.041V20.655L18.0497 20.642ZM17.6853 16.5943V20.3687H17.6983L17.6853 16.5943ZM14.4315 16.5943V20.3687H14.4445L14.4315 16.5943ZM16.7352 20.0693H15.2905V20.0823L16.7352 20.0693ZM18.0497 12.937V13.6008H18.0627L18.0497 12.937ZM14.0931 12.963V13.5748H14.1061L14.0931 12.963ZM18.0497 13.4056H14.0931V13.4186L18.0497 13.4056Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.9002 13.9004H14.6529L14.6269 15.8136H14.9262L14.9002 13.9004Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.9002 13.9004H14.6529L14.6269 15.8136H14.9262L14.9002 13.9004L14.9132 15.8006H14.6399L14.6659 13.9134H14.9002V13.9004Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.2039 13.9004H17.4381L17.4642 15.8136H17.1518L17.2039 13.9004Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.2038 13.9004V13.9134H17.4381L17.4641 15.8006H17.1518L17.2038 13.9004V13.9134V13.9004H17.1908L17.1388 15.8136H17.4641H17.4772L17.4511 13.9004H17.2038H17.1908H17.2038Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.0998 15.9043H16.7354V16.2557H17.0998V15.9043Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.7352 16.2557H17.1126V15.9043H16.7222V16.2557H16.7352V15.9173H17.0996V16.2427H16.7352V16.2557Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.5405 15.9043H16.124V16.2557H16.5405V15.9043Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.1234 16.2557H16.5399V15.9043H16.1104V16.2557H16.1234V15.9173H16.5268V16.2427H16.1234V16.2557Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.9547 15.9043H15.5122V16.2557H15.9547V15.9043Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.5122 16.2557H15.9547V15.9043H15.5122V16.2557V15.9173H15.9417V16.2427H15.5122V16.2557Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.3427 15.9043H15.0043V16.2557H15.3427V15.9043Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.0043 16.2557H15.3427V15.9043H15.0043H14.9913V16.2557H15.0043V15.9173H15.3297V16.2427H15.0043V16.2557Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.7962 15.9043H14.4317V16.2557H14.7962V15.9043Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.4317 16.2557H14.8092V15.9043H14.4317V16.2557H14.4447V15.9173H14.7962V16.2427H14.4317V16.2557H14.4447H14.4317Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.6852 15.9043H17.3208V16.2557H17.6852V15.9043Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.3208 15.9043V15.9173H17.6852V16.2427H17.3208V15.9043V15.9173V15.9043V16.2557H17.6982V15.9043H17.3208Z",
    fill: "black"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_3081_16670"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    rx: 16,
    fill: "white"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgEthniki);
export default __webpack_public_path__ + "static/media/ethniki.f3e3908419add5b954a36b6872d811f6.svg";
export { ForwardRef as ReactComponent };